<span>
  <label class="block mb-1 text-color-secondary" [iosRequired]="isRequired" *ngIf="!onlyFlag">{{ label | translate }}</label>
  <p-dropdown
    [options]="languages | cacheValues : language.value?.languageId"
    [formControl]="language"
    styleClass="w-full"
    class="ios-selector-large"
    appendTo="body"
    placeholder="{{ 'LABEL.SELECT_LANG' | translate }}"
    optionDisabled="disabled"
    [autoDisplayFirst]="false"
    [disabled]="isDisabled"
    (focus)="onTouched()"
  >
    <ng-template let-selectedLang pTemplate="selectedItem">
      <div class="flex align-content-center">
        <span class="fi fi-{{ selectedLang?.countryCode | lowercase }}"></span>
        <div *ngIf="!onlyFlag" class="ml-4">{{ selectedLang?.name }}</div>
      </div>
    </ng-template>
    <ng-template let-lang pTemplate="item">
      <div class="flex align-content-center">
        <span class="fi fi-{{ lang?.countryCode | lowercase }}"></span>
        <div class="ml-4">{{ lang?.name }}</div>
      </div>
    </ng-template>
  </p-dropdown>
</span>
